<template>
    <div class="main-container">
        <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch" label-width="90px">
            <el-form-item label="公众号名称" prop="appName">
                <el-input v-model="searchForm.appName" placeholder="公众号名称" style="width: 230px"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                <el-button @click="handleReset" size="small">重置</el-button>
            </el-form-item>
        </el-form>

        <div style="padding-bottom: 10px">
            <el-button  icon="el-icon-plus" type="primary" size="small" @click="handleAdd">添加</el-button>
        </div>

        <el-table :data="appList" border style="width: 100%" size="small"  v-loading="isLoading" element-loading-text="拼命加载中">
            <el-table-column type="index" prop="index" label="#" width="60" align="center" fixed="left"></el-table-column>
            <el-table-column prop="appName" label="公众号名称" width="200"></el-table-column>
            <!-- <el-table-column prop="type" label="类型">
                <template slot-scope="{ row }">
                    <el-tag>{{row.appType === 1 ? '支付端' : '公众号后台'}}</el-tag>
                </template>
            </el-table-column> -->
            <el-table-column prop="principalName" label="公众号主体" width="200"></el-table-column>
            <el-table-column prop="appId" label="appId" width="120"></el-table-column>
            <el-table-column prop="secret" label="appSecret" width="220"></el-table-column>
            <el-table-column prop="wxSign" label="原始Id" width="150"></el-table-column>
            <el-table-column prop="aesKey" label="EnAeSKey" width="120"></el-table-column>
            <el-table-column prop="token" label="token" width="120"></el-table-column>
            <el-table-column prop="qrCode" label="二维码图片" width="120">
                <template slot-scope="{ row }">
                    <el-image  style="width: 50px; height: 50px" :src="row.qrCode"  :preview-src-list="[row.qrCode]"></el-image>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="220" align="center" prop="action" fixed="right">
                <template slot-scope="{ row }">
                    <el-button type="text" size="mini" style="margin-right: 5px" @click="handleEdit(row)">编辑</el-button>
                    <el-button type="text" size="mini" style="margin-right: 5px" @click="handleWxtemplatemsg(row)">同步模板</el-button>
                    <el-button type="text" size="mini" style="color:red" @click="handleDelete(row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="text-align: right; padding: 10px 20px 0 0;">
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total" :page-sizes="[10, 20, 50]"  :current-page.sync="searchForm.pageNumber" :page-size="searchForm.pageSize" @current-change="handleChangePage" @size-change="handleChangePageSize"></el-pagination>
        </div>
        <el-dialog :title="modelForm.id ? '编辑公众号' : '新增公众号'" :visible.sync="isShow" width="750px">
            <el-form ref="modelForm" :model="modelForm" inline label-width="95px" size="small" :rules="modelFormValidate">
                <el-form-item label="app名称" prop="appName">
                    <el-input type="text" v-model="modelForm.appName" clearable placeholder="请输入app名称" style="width: 230px"/>
                </el-form-item>

                <el-form-item label="公众号主体" prop="principalName">
                    <el-input type="text" v-model="modelForm.principalName" clearable placeholder="请输入商户主体名称" style="width: 230px"/>
                </el-form-item>

                <el-form-item label="公众号类型" prop="accountType">
                    <el-select v-model="modelForm.accountType" placeholder="请选择" style="width: 230px">
                        <el-option label="订阅号" :value="0"></el-option>
                        <el-option label="由历史老帐号升级后的订阅号" :value="1"></el-option>
                        <el-option label="服务号" :value="2"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="微信原始Id" prop="wxSign">
                    <el-input type="text" v-model="modelForm.wxSign" clearable placeholder="请输入原始Id" style="width: 230px"/>
                </el-form-item>

                <el-form-item label="appId" prop="appId">
                    <el-input type="text" v-model="modelForm.appId" clearable placeholder="请输入appId" style="width: 230px"/>
                </el-form-item>
                
                <el-form-item label="appSecret" prop="secret">
                    <el-input type="text" v-model="modelForm.secret" clearable placeholder="请输入appSecret" style="width: 230px"/>
                </el-form-item>

                <el-form-item label="token" prop="token">
                    <el-input type="text" v-model="modelForm.token" clearable placeholder="请输入token" style="width: 230px"/>
                </el-form-item>

                <el-form-item label="EnAeSKey" prop="aesKey">
                    <el-input type="text" v-model="modelForm.aesKey" clearable placeholder="请输入EnAeSKey" style="width: 230px"/>
                </el-form-item>

                <el-form-item label="备注" prop="remarks">
                    <el-input type="textarea" v-model="modelForm.remarks" :row="2" clearable placeholder="请输入备注" style="width: 230px"/>
                </el-form-item>

                <el-form-item label="二维码" prop="qrCode">
                    <el-upload
                        class="avatar-uploader"
                        action="/room/upload/img"
                        :headers="headers"
                        name="mulFile"
                        :data="{ key: 'head'}"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="modelForm.qrCode" :src="modelForm.qrCode" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>

            </el-form>
            <div slot="footer">
                <el-button type="text" size="small" @click="isShow = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmit('modelForm')">提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
export default {
    computed: {
        headers() {
            return {
                "Authorization":  localStorage.getItem('Token'),
            }
        },
        
    },
    components: {
    },
    data() {
        
        return {
            appList: [],
            total: 0,
            searchForm: {
                appType: 2,
                appName: "",
                appId: "",
                pageNumber: 1,
                pageSize: 10,
            },
            isLoading: false,
            isShow: false,
            modelForm: {
                appName: "",
                appType: 2,
                verifyType: 2,
                accountType: "",
                appId: "",
                secret: "",
                principalName: "",
                wxSign: '',
                token: "",
                qrCode: "",
                aesKey: "",
                remarks: "",
            },
            accessToken: {},
            showTempMsg: false,
            modelFormValidate: {
                appName: [{ required: true, message: "请输入公众号名称", trigger: "blur" }],
                appId: [{ required: true, message: "请输入appId", trigger: "blur" }],
                secret: [{ required: true, message: "请输入appSecret", trigger: "blur" }],
                principalName: [{ required: true, message: "请输入商户主体名称", trigger: "blur" }],
                wxSign: [{ required: true, message: "请输入原始Id", trigger: "blur" }],
                accountType: [{ required: true, message: "请选择公众号类型", trigger: "blur" }], 
                token: [{ required: true, message: "请输入token", trigger: "blur" }],
                aesKey: [{ required: true, message: "请输入aesKey", trigger: "blur" }], 
            },
            submitLoading: false,

        }
    },
    created() {
        this.getAppList();
    },
    methods: {
        handleWxtemplatemsg(item){
            this.$confirm('确定要同步该公众号的模板?','温馨提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message.warning("同步中,请稍后...");
                this.postRequest(`/df-wx/templateMsg/syncTemplate?appId=${item.appId}`)
                .then(res => {
                    let data = res.data;
                    if(data.code == 200){
                        this.$message.success(data.msg);
                    }
                })
            })
        },
        handleSubmit(formName) {
            this.$refs[formName].validate((valid) => {
                if(valid) {
                    if(!!this.modelForm.id) {
                        this.postRequest("/df-wx/wxApp/updateWxApp", this.modelForm)
                        .then(res => {
                            let data = res.data;
                            if(data.code == 200) {
                                this.isShow = false;
                                this.getAppList();
                                this.$message.success(data.msg);
                            } else {
                                this.$message.warning(data.msg);
                            }
                        })
                    } else {
                        this.postRequest("/df-wx/wxApp/addWxApp", this.modelForm)
                        .then(res => {
                            let data = res.data;
                            if (data.code == 200) {
                                this.isShow = false;
                                this.getAppList();
                                this.$message.success(data.msg);
                            } else {
                                this.$message.warning(data.msg);
                            }
                        })
                    }
                }
            })
        },
        handleEdit(row) {
            this.getRequest(`/df-wx/wxApp/getById?id=${row.id}`)
            .then(res => {
                this.isLoading = false;
                let data = res.data;
                if(data.code == 200) {
                    this.modelForm = data.data;
                    this.isShow = true;
                }
            })
        },
        handleDelete(row) {
            this.$confirm('确认删除该公众号, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.postRequest("/df-wx/wxApp/deleteBatchWxApp",[row.id])
                .then(res => {
                    let data = res.data;
                        if (data.code == 200) {
                            this.getAppList();
                            this.$message.success(data.msg);
                        } else {
                            this.$message.warning(data.msg);
                        }
                })
            })
        },
        handleAdd() {
            this.modelForm = {
                appName: "",
                appType: 2,
                verifyType: 2,
                accountType: "",
                appId: "",
                secret: "",
                principalName: "",
                wxSign: '',
                token: "",
                qrCode: "",
                aesKey: "",
                remarks: "",
            }
            this.isShow = true;
        },
        handleAvatarSuccess(res, file) {
            this.modelForm.qrCode = res.data;
        },
        beforeAvatarUpload(file) {
            const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/png');
            const isLt2M = file.size / 1024 / 1024 < 10;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 10MB!');
            }
            return isJPG && isLt2M;
        },
        handleReset() {
            this.searchForm = {
                appType: 2,
                appName: "",
                pageNumber: 1,
                pageSize: 10,
            };
            this.getAppList();
        },
        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getAppList();
        },
       
        handleChangePage(currentPage) {
            this.searchForm.pageNumber = currentPage;
            this.getAppList();
        },
        handleChangePageSize(pageSize) {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = pageSize;
            this.getAppList();
        },
        getAppList() {
            this.isLoading = true;
            this.getRequest("/df-wx/wxApp/getPage", this.searchForm)
            .then(res => {
                this.isLoading = false;
                let data = res.data;
                if(data.code == 200) {
                    this.appList = data.data.records;
                    this.total = data.data.total;
                }
            })
        }
    },
}

</script>

<style>
    @import url("./index.less");
</style>